import { FaFileMedical } from "react-icons/fa";
import { useImagesContext } from "./context";
import "./imgCard.scss";

interface IAddImageCardProps {
  formTyp: "create" | "update";
}

const AddImageCard: React.FC<IAddImageCardProps> = ({ formTyp }) => {
  const { onAdd } = useImagesContext();
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files;
    if (!files) return;

    onAdd({ files, formTyp });
  };

  return (
    <label className="image-card-img-add">
      <FaFileMedical size={20} />
      <input type="file" hidden multiple onChange={onChange} />
    </label>
  );
};

export default AddImageCard;
